import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AdminResponseDto } from '@api/generated/model';

type AuthState = {
	// State
	admin: AdminResponseDto | null; // 관리자 정보
	accessToken: string | null;
	isAuthenticated: boolean; // 인증 여부
	isLoading: boolean; // 로딩 상태
	// Action
	setAdmin: (admin: AdminResponseDto | null) => void;
	setAccessToken: (token: string | null) => void;
	setIsAuthenticated: (isAuthenticated: boolean) => void;
	setIsLoading: (isLoading: boolean) => void;
	login: (admin: AdminResponseDto, accessToken: string) => void;
	logout: () => void;
	reset: () => void;
}

// 초기 상태
const initialState = {
	admin: null,
	accessToken: null,
	isAuthenticated: false,
	isLoading: true
};

export const useAuthStore = create<AuthState>()(
	persist(
		(set) => ({
			...initialState,
			// setter 함수
			setAdmin: (admin) => set({ admin }),
			setAccessToken: (accessToken) => set({ accessToken }),
			setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
			setIsLoading: (isLoading) => set({ isLoading }),
			// 로그인
			login: (admin, accessToken) => set({
				admin,
				accessToken,
				isAuthenticated: true,
				isLoading: false
			}),
			// 로그아웃
			logout: () => set({
				admin: null,
				accessToken: null,
				isAuthenticated: false,
				isLoading: false
			}),
			// 전체 초기화
			reset: () => set(initialState)
		}),
		{
			name: 'auth-storage',
			storage: createJSONStorage(() => localStorage),
			partialize: (state) => ({
				// 보안을 위해 오직 인증 여부만 localStorage에 저장
				// accessToken과 admin 정보는 메모리에만 저장
				// 새로고침 시 AuthInitializer에서 자동으로 재조회
				isAuthenticated: state.isAuthenticated
			})
		}
	)
);
